import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbActiveModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Observable, OperatorFunction, debounceTime, switchMap } from 'rxjs';
import { IdentityWhitelabelApiClient } from 'src/app/services/api-clients/identity-whitelabel.api-client';
import { WhitelabelInformationModel } from 'src/app/models/whitelabel-information.model';
import { WhiteLabelInfoModel } from '../../ids-for-settings.service';
import { IdentitySystemApiClient } from 'src/app/services/api-clients/identity-system.api-client';

@Component({
  templateUrl: './change-whitelabel.modal.html'
})
export class ChangeWhiteLabelModal {
  @Output('whiteLabelInfo') whiteLabelInfo: EventEmitter<WhitelabelInformationModel> = new EventEmitter();
  searchWhiteLabelInput: FormControl;
  selectedWhiteLabel: WhiteLabelInfoModel = new WhiteLabelInfoModel("", "");
  systemGuid!: string;
  searchWhiteLabelFunction: OperatorFunction<string, WhitelabelInformationModel[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      switchMap((search) =>
        search.length < 2 ? [] : this.identitySystemApiClient.getFilteredWhiteLabel(this.systemGuid, search)
      ),
    );

  constructor(private activeModal: NgbActiveModal, private identitySystemApiClient: IdentitySystemApiClient) {
    this.searchWhiteLabelInput = new FormControl("");
  }


  change() {
    this.whiteLabelInfo.emit(this.selectedWhiteLabel);
    this.activeModal.close();
  }

  selectWhiteLabel(event: NgbTypeaheadSelectItemEvent) {
    event.preventDefault();
    this.searchWhiteLabelInput.patchValue(event.item.enterpriseName, { onlySelf: true });
    this.selectedWhiteLabel = new WhiteLabelInfoModel(event.item.enterpriseGuid, event.item.enterpriseName);
  }

  close() {
    this.activeModal.close();
  }

}
